<div odxLayout="grid" [formGroupName]="groupName">
  <span odxLayout="10 4@desktop 5@tablet" class="odx-text">{{ label }}</span>
  <odx-switch
    odxLayout="2 1@tablet"
    formControlName="checked"
    [readonly]="(isReadOnlyUser$ | async) === true || (hasWritePermission$ | async) === false"
  >
  </odx-switch>

  <div odxLayout="12 5@desktop 6@tablet">
    @if (subLabel) {
      <p [class.text-disabled]="disabled">{{ subLabel }}</p>
    }

    <odx-radio-group
      formControlName="choice"
      [horizontal]="!isPhone()"
      [readonly]="(isReadOnlyUser$ | async) === true || (hasWritePermission$ | async) === false"
      class="group"
    >
      @for (option of options; track option.value) {
        <odx-radio-button [value]="option.value">{{ option.label }}</odx-radio-button>
      }
    </odx-radio-group>
  </div>
</div>
